var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Games!!")]),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/codenames","link":""}},[_vm._v("\n        codenames\n        ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }